// Listar archivos de un bucket específico
export const listFiles = async (bucketUrl) => {
  const response = await fetch(`${bucketUrl}?list-type=2`);
  const xml = await response.text();
  const parser = new DOMParser();
  const xmlDoc = parser.parseFromString(xml, 'application/xml');
  const items = Array.from(xmlDoc.getElementsByTagName('Contents')).map(item => {
    return item.getElementsByTagName('Key')[0].textContent;
  });
  return items;
};
